var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Stats } from "./Stats";
import { VotesPerDay } from "../charts/VotesPerDay";
import { DEFAULT_VOTES_TIME_SELECTION, getVotesBucketCount, } from "../charts/votesTimeRange";
import { daysBefore, formatDate, getToday } from "../charts/Charts";
import { VotersByChannel } from "../charts/VotersByChannel";
import { toVotersByChannelRows } from "../charts/votersByChannelData";
import { useRecordContext } from "react-admin";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useQuery } from "@apollo/client";
import { GET_ELECTION_STATS } from "@/queries/GetElectionStats";
import { translateFromPresentation } from "@sequentech/ui-core";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { ListIpAddress } from "@/resources/ElectionEvent/ListIpAddress";
import { useTranslation } from "react-i18next";
var Container = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n"])));
export default function DashboardElection() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var i18n = useTranslation().i18n;
    var tenantId = useTenantStore()[0];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var record = useRecordContext();
    var _p = useState(DEFAULT_VOTES_TIME_SELECTION), votesTimeSelection = _p[0], setVotesTimeSelection = _p[1];
    var electionAlias = record
        ? translateFromPresentation(record.presentation, "alias", i18n.language)
        : undefined;
    var endDate = getToday();
    var startDate = daysBefore(endDate, 6);
    var userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var authContext = useContext(AuthContext);
    var showIpAdresses = authContext.isAuthorized(true, authContext.tenantId, IPermissions.ELECTION_IP_ADDRESS_VIEW);
    // Ensure required parameters are set before running the query.
    var canQueryStats = Boolean(tenantId && (record === null || record === void 0 ? void 0 : record.election_event_id) && (record === null || record === void 0 ? void 0 : record.id));
    var _q = useQuery(GET_ELECTION_STATS, {
        variables: {
            tenantId: tenantId,
            electionEventId: record === null || record === void 0 ? void 0 : record.election_event_id,
            electionId: record === null || record === void 0 ? void 0 : record.id,
            startDate: formatDate(startDate),
            endDate: formatDate(endDate),
            electionAlias: electionAlias !== null && electionAlias !== void 0 ? electionAlias : undefined,
            userTimezone: userTimezone,
            timeResolution: votesTimeSelection.resolution,
            bucketCount: getVotesBucketCount(votesTimeSelection),
        },
        fetchPolicy: "network-only",
        pollInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
        skip: !canQueryStats,
    }), loading = _q.loading, dataStats = _q.data;
    if (loading) {
        return _jsx(CircularProgress, {});
    }
    var stats = (_b = (_a = dataStats === null || dataStats === void 0 ? void 0 : dataStats.election) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.statistics;
    var metrics = {
        eligibleVotersCount: (_d = (_c = dataStats === null || dataStats === void 0 ? void 0 : dataStats.users) === null || _c === void 0 ? void 0 : _c.count) !== null && _d !== void 0 ? _d : "-",
        votersCount: (_f = (_e = dataStats === null || dataStats === void 0 ? void 0 : dataStats.stats) === null || _e === void 0 ? void 0 : _e.total_distinct_voters) !== null && _f !== void 0 ? _f : "-",
        areasCount: (_h = (_g = dataStats === null || dataStats === void 0 ? void 0 : dataStats.stats) === null || _g === void 0 ? void 0 : _g.total_areas) !== null && _h !== void 0 ? _h : "-",
        emailsSentCount: (_j = stats === null || stats === void 0 ? void 0 : stats.num_emails_sent) !== null && _j !== void 0 ? _j : "-",
        smsSentCount: (_k = stats === null || stats === void 0 ? void 0 : stats.num_sms_sent) !== null && _k !== void 0 ? _k : "-",
    };
    var cardWidth = 470;
    var cardHeight = 250;
    return (_jsx(Box, { sx: { width: 1024, marginX: "auto" }, className: "dashboard", children: _jsxs(Box, { children: [_jsx(Stats, { metrics: metrics }), _jsxs(Container, { children: [_jsx(VotesPerDay, { data: (_m = (_l = dataStats === null || dataStats === void 0 ? void 0 : dataStats.stats) === null || _l === void 0 ? void 0 : _l.votes_per_day) !== null && _m !== void 0 ? _m : null, width: cardWidth, height: cardHeight, selection: votesTimeSelection, onSelectionChange: setVotesTimeSelection }), _jsx(VotersByChannel, { data: toVotersByChannelRows((_o = dataStats === null || dataStats === void 0 ? void 0 : dataStats.stats) === null || _o === void 0 ? void 0 : _o.voters_by_channel), width: cardWidth, height: cardHeight })] }), showIpAdresses && (record === null || record === void 0 ? void 0 : record.id) && _jsx(ListIpAddress, {})] }) }));
}
var templateObject_1;
